<div (focusout)="onBlur()" class="form-group d-flex flex-column">
  @if(label){
  <label for="dropdown-select" class="col-form-label">{{ label }}</label>
  }
  <p-select
    id="dropdown-select"
    [options]="dataSource"
    [(ngModel)]="selectedItem"
    optionLabel="name"
    [placeholder]="placeholder"
    class=" rounded dropdown-wrapper d-flex align-items-center"
    (onChange)="onSelect($event.value)"
    [disabled]="disabled"

  />
</div>
